import Button from '../../../../../components/Button/Button';
import DownloadFileLink from '../../../../../components/DownloadFileLink/DownloadFileLink';
import DocsInputNew from '../../../../../components/Inputs/DocsInput/DocsInputNew';
import { colors } from '../../../../../constants/colors';
import { FLOW_ECP, FLOW_PRINT, displayPhone, formatWhen, personName } from './form';
import { card, hint, title } from './parts';

const ROLE_LABEL = { seller: 'ÐÑÐ¾Ð´Ð°Ð²ÐµÑ', buyer: 'ÐÐ¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ', agent: 'ÐÐ³ÐµÐ½Ñ' };

// ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¿Ð»Ð¾ÑÐ°Ð´ÐºÐ¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÐºÐ°Ðº ÐµÑÑÑ: ÐÐÐ¤ Ð±ÑÐ²Ð°ÐµÑ Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð¢ÐÐ, Ð° Ð²
// Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð¸Ð´ÑÑ ÑÐ¾ Ð¶Ðµ ÑÑÐ»Ð¸ÑÐ¾, ÑÑÐ¾ Ð¸ Ð² ÑÑÐ¾Ð¼ ÑÐ¿Ð¸ÑÐºÐµ.
const agentCompany = (raw) => String(raw || '').trim() || 'ÐÐ³ÐµÐ½Ñ';

const TextAction = ({ disabled, onClick, children }) => (
  <span
    role="button"
    tabIndex={disabled ? -1 : 0}
    onClick={disabled ? undefined : onClick}
    onKeyDown={(event) => {
      if (disabled) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    }}
    style={{
      color: disabled ? colors.dimGray : colors.cameo,
      cursor: disabled ? 'default' : 'pointer',
      textDecoration: 'underline',
      fontSize: 14,
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </span>
);

const ecpPartyPhone = (state, form, role) => {
  if (role === 'agent') return form.agent?.phone || state?.parties?.agent?.phone;
  return form[role]?.phone || state?.parties?.[role]?.phone || state?.values?.[role]?.phone;
};

const Document = ({
  file,
  state,
  form,
  flow,
  busy,
  sendingSms,
  signedFile,
  setSignedFile,
  uploading,
  onSendEcp,
  onRestartEcp,
  onUploadSigned,
}) => {
  if (!file?.url) return null;
  const ecp = state?.ecp || {};
  const signers = ecp.signers || [];
  const ecpStarted = signers.some((s) => s.status === 'sms' || s.status === 'signed');

  return (
    <div style={{ ...card, background: '#fff' }}>
      <p style={title}>ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ</p>
      <DownloadFileLink
        document={{
          ...file,
          url: ecp.currentUrl || file.url,
          type: { title: ecp.signedCount ? `ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Â· ${ecp.signedCount} Ð¸Ð· 3 Ð¿Ð¾Ð´Ð¿Ð¸ÑÐµÐ¹` : 'Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ' },
        }}
      />
      {ecp.unsignedUrl && ecp.unsignedUrl !== (ecp.currentUrl || file.url) && (
        <a href={ecp.unsignedUrl} target="_blank" rel="noreferrer" style={{ ...hint, color: colors.cameo }}>
          Ð¤Ð°Ð¹Ð» Ð±ÐµÐ· Ð¿Ð¾Ð´Ð¿Ð¸ÑÐµÐ¹
        </a>
      )}
      {flow === FLOW_ECP && (
        <div style={{ marginTop: 8 }}>
          {ecp.stage === 'complete' ? <p style={hint}>ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½.</p> : null}
          {['seller', 'buyer', 'agent'].map((role, index) => {
            const signer = signers.find((s) => s.role === role) || {};
            const name =
              signer.name ||
              (role === 'agent' ? form.agent?.director : personName(form[role])) ||
              'â';
            const phone = signer.phone || ecpPartyPhone(state, form, role);
            const isNext = ecp.nextRole === role && ecp.stage !== 'complete';
            const waiting = signer.status === 'sms';
            const signed = signer.status === 'signed';
            const heading =
              role === 'agent' ? `${ROLE_LABEL[role]} Â· ${agentCompany(state?.values?.agent?.name)}` : `${index + 1}. ${ROLE_LABEL[role]}`;
            const who =
              role === 'agent' && name && name !== 'â'
                ? `${name}, Ð¿ÑÐµÐ´ÑÑÐ°Ð²Ð¸ÑÐµÐ»Ñ`
                : name;
            return (
              <div
                key={role}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 12,
                  padding: '12px 0',
                  borderTop: '1px solid #eee',
                }}
              >
                <div>
                  <p style={{ fontWeight: 600 }}>
                    {role === 'agent' ? `3. ${heading}` : heading}
                  </p>
                  <p style={{ ...hint, margin: 0 }}>
                    {who}
                    {signed && signer.signedAt ? ` Â· Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¾ ${formatWhen(signer.signedAt)}` : ''}
                    {waiting && signer.smsAt ? ` Â· Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ ${formatWhen(signer.smsAt)}` : ''}
                    {!signed && !waiting && phone ? ` Â· ${displayPhone(phone)}` : ''}
                    {!signed && !waiting && !phone ? ' Â· Ð½ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°' : ''}
                  </p>
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center' }}>
                  {signed && (signer.copyUrl || signer.signedPdfUrl) && (
                    <TextAction
                      onClick={() => window.open(signer.copyUrl || signer.signedPdfUrl, '_blank', 'noopener,noreferrer')}
                    >
                      ÐÑÐºÑÑÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ
                    </TextAction>
                  )}
                  {waiting && signer.link && (
                    <TextAction onClick={() => window.open(signer.link, '_blank', 'noopener,noreferrer')}>
                      ÐÑÐºÑÑÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ
                    </TextAction>
                  )}
                  {isNext && waiting && (
                    <TextAction disabled={busy || sendingSms === role} onClick={() => onSendEcp(role)}>
                      {sendingSms === role ? 'ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼â¦' : 'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾'}
                    </TextAction>
                  )}
                  {isNext && !waiting && (
                    <Button
                      disabled={busy || !phone}
                      text={sendingSms === role ? 'ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼â¦' : 'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡'}
                      fill
                      onClick={() => onSendEcp(role)}
                    />
                  )}
                </div>
              </div>
            );
          })}
          {ecpStarted && (
            <p style={{ ...hint, margin: '12px 0 0' }}>
              <TextAction disabled={busy} onClick={onRestartEcp}>
                ÐÐ°ÑÐ°ÑÑ Ð­Ð¦Ð Ð·Ð°Ð½Ð¾Ð²Ð¾
              </TextAction>
            </p>
          )}
        </div>
      )}
      {flow === FLOW_PRINT &&
        (state.signedDocument ? (
          <p style={{ ...hint, color: '#1E6B2E', marginTop: 12 }}>
            Ð¡ÐºÐ°Ð½ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½ Â·{' '}
            <a href={state.signedDocument.url} target="_blank" rel="noreferrer" style={{ color: colors.cameo }}>
              Ð¾ÑÐºÑÑÑÑ
            </a>
          </p>
        ) : (
          <div style={{ marginTop: 16 }}>
            <DocsInputNew
              id="tripartite-signed"
              text="Ð¡ÐºÐ°Ð½ (Ð½ÐµÐ¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾)"
              label={signedFile?.name || 'PDF Ð¸Ð»Ð¸ ÑÐ¾ÑÐ¾'}
              value={signedFile}
              onChange={setSignedFile}
              accept="application/pdf,image/*"
            />
            <div style={{ marginTop: 12 }}>
              <Button disabled={uploading || !signedFile} text="ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐºÐ°Ð½" onClick={onUploadSigned} />
            </div>
          </div>
        ))}
    </div>
  );
};

export default Document;
export { ROLE_LABEL };
